<script setup lang="ts">
import isArray from 'lodash/isArray'
import Anchor from '~/components/Anchor.vue'
import isSlug from '~/routeValidators/isSlug'
import { useConfigStore } from '~/store/useConfigStore'

definePageMeta({
  validate: isSlug,
})

const { show } = usePagesApi()

const { params } = useRoute()

const config = useConfigStore()

const slug = computed<string>(() => {
  const slugs = params.slug

  if (isArray(slugs) && slugs.length > 0) {
    const filteredSlugs = slugs.filter(Boolean)

    return filteredSlugs[filteredSlugs.length - 1]
  }

  return slugs?.toString()
})

const { data: page, error } = await useAsyncData(`page-${slug.value}`, () => show(slug.value))

if (!page.value || error.value) {
  throw createError({
    status: 404,
    statusText: 'Page not found.',
    fatal: true,
  })
}

if (config.$state.homepagePageId && page.value.data.id === config.$state.homepagePageId) {
  await navigateTo({ name: 'index' })
}

const { contentBlocks, title, shortDescription, metaTitle, metaDescription } = useArticle(page.value.data)

useHead({
  title: title.value,
})

useSeoMeta({
  title: title.value,
  ogDescription: metaDescription?.value || shortDescription.value || config.$state.websiteDescription,
  ogTitle: metaTitle?.value || title.value || config.$state.websiteTitle,
})
</script>

<template>
  <section>
    <template
      v-for="{ id, component, data } in contentBlocks"
      :key="id"
    >
      <Anchor :id="id" />
      <Component
        :is="component"
        v-bind="data"
      />
    </template>
  </section>
</template>
